var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section--ourwork"},[_c('div',{staticClass:"worklist"},_vm._l((_vm.workList),function(item,index){return _c('app-worklist',{key:item.name,class:'img' + (index + 1),style:({ gridArea: 'img' + (index + 1) }),attrs:{"item":item,"delay":index}})}),1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d578ece0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/landing/OurWork.vue
// module id = null
// module chunks = 